import { render, staticRenderFns } from "./OrderReturn.vue?vue&type=template&id=d291518c&scoped=true&"
import script from "./OrderReturn.vue?vue&type=script&lang=js&"
export * from "./OrderReturn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d291518c",
  null
  
)

export default component.exports